import { useState } from "react";
import Radio from "@mui/material/Radio";
import { FormControl, FormControlLabel, RadioGroup } from "@mui/material";

export default function RadioBtn({ id, onAttendanceChange, isPresent, edit }) {
  const [selectedValue, setSelectedValue] = useState(
    edit ? (isPresent ? "1" : "0") : isPresent ? (isPresent ? "1" : "0") : "1"
  );
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    onAttendanceChange({ student_id: id, is_present: event.target.value });
  };

  return (
    <FormControl>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        onChange={handleChange}
        value={selectedValue}
      >
        <FormControlLabel value={"1"} control={<Radio />} label="حاضر" />
        <FormControlLabel value={"0"} control={<Radio />} label="غایب" />
      </RadioGroup>
    </FormControl>
  );
}
